import { createFileRoute } from '@tanstack/react-router';
import { requireRole } from '@/lib/routeGuards';
import { AssistantTelemetryRun } from '@/components/admin/assistant-telemetry';

export const Route = createFileRoute('/admin/assistant-telemetry/runs/$runId')({
  beforeLoad: ({ context, location }) => {
    requireRole(context, ['admin'], location.pathname);
  },
  component: RunRoute,
});

function RunRoute() {
  const { runId } = Route.useParams();
  return <AssistantTelemetryRun runId={runId} />;
}
